import { z } from "zod";
import { INBOX_TABS } from "@/features/pulse-surveys/lib/inbox-tabs";

/// The open tab and the selected conversation live in the URL so going back
/// from a thread, or sharing the link, lands on the same view. An unknown tab
/// falls back to the default one.
export const pulseAnswerThreadsSearchSchema = z.object({
  tab: z.enum(INBOX_TABS).optional().catch(undefined),
  thread: z.string().min(1).optional().catch(undefined),
});
